import styled from "styled-components";
import { BRAND, GRAY_LIGHTEST } from "@streeteasy/design-system/colors";

const CalendarOptionContainer = styled.a`
  align-items: center;
  display: flex;
  margin: 0 -16px 0 -16px;
  padding: 7px;

  &:hover {
    background-color: ${GRAY_LIGHTEST};
  }
`;

const Icon = styled.i`
  color: ${BRAND};
  margin-right: 10px;
`;

Icon.displayName = "Icon";

export { CalendarOptionContainer, Icon };
